<template>
    <li class="education-filter">
        <div
            class="education-filter__name"
            :class="{ 'education-filter__name--disabled': !filter.isActive }"
            @click="emitToggleEvent"
        >
            {{ filter.name }}
            <i class="fas fa-chevron-down fa-pull-right"></i>
        </div>
        <ul class="education-filter__options selected-items ">
            <li
                v-for="(item, index) in selectedFilters"
                :key="index"
                @click="removeFilter(item)"
            >
                <i class="fa fa-check"> </i> {{ item.name }}
            </li>
        </ul>
        <ul
            class="education-filter__options collapse-item"
            :style="computedStyle"
        >
            <li
                v-for="item in filter.filters.filter(
                    x => !value.find(y => y.id == x.id)
                )"
                v-show="item.resultsTotalFound > 0"
                :key="item.id + item.filter"
                class="education-filter__option"
            >
                <input
                    :id="item.id + item.filter"
                    v-model="selectedFilters"
                    class="education-filter__input"
                    type="checkbox"
                    :value="item"
                    @input="changeHandler(item)"
                />
                <label
                    :for="item.id + item.filter"
                    class="education-filter__label"
                    :class="{ disabled: item.resultsFound === 0 }"
                >
                    {{ item.name }}
                    <span>({{ item.resultsFound }})</span>
                </label>
            </li>
        </ul>
    </li>
</template>

<script>
import { EventBus } from '@/js/helpers/eventbus';
import CollapseMixin from '@/js/mixins/collapse-mixin';

export default {
    mixins: [CollapseMixin],
    props: {
        filter: {
            type: Object,
            default() {
                return {};
            }
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        multiSelect: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isActive: false,
            selectedFilters: this.value,
            otherFilters: []
        };
    },

    watch: {
        selectedFilters(val) {
            this.$emit('input', val);
        }
    },

    mounted() {
        EventBus.$on('remove-filter', this.removeFilter);
        EventBus.$on('toggle-sub-item', this.toggleFilter);
    },

    beforeDestroy() {
        EventBus.$off('remove-filter', this.removeFilter);
        EventBus.$off('toggle-sub-item', this.toggleFilter);
    },

    methods: {
        changeHandler(item) {
            if (item.resultsFound === 0) {
                return;
            }
            if (!this.multiSelect) {
                const array = [];
                array.push(item);
                this.selectedFilters = array;
            }
        },

        removeFilter(filter) {
            this.selectedFilters = this.selectedFilters.filter(
                item => item.filter !== filter.filter
            );
        },

        emitToggleEvent() {
            EventBus.$emit('toggle-sub-item', this.filter.id);
        },

        toggleFilter(id) {
            if (this.filter.id === id) {
                this.isActive = !this.isActive;
            } else {
                this.isActive = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~@fortawesome/fontawesome-free/scss/fontawesome';
@import '~@fortawesome/fontawesome-free/scss/solid';

.education-filter {
    margin-bottom: 0.5rem;
}
.education-filter__name {
    font-size: 1.25rem;
    text-transform: uppercase;

    i {
        margin-top: 4px;
    }

    &:hover {
        cursor: pointer;
    }

    &--disabled {
        cursor: default;
        opacity: 0.5;
        i {
            display: none;
        }
    }
}

.education-filter__options {
    margin: 0;
    padding-left: 0;
    list-style: none;
    font-weight: $font-weight-light;
    font-size: 1.125rem;
    letter-spacing: 0.33px;

    i {
        color: $color-blue;
        padding-right: 4px;
        position: relative;
        bottom: -1px;
    }
}

.education-filter__input {
    display: none;
}

.education-filter__input + .education-filter__label {
    position: relative;
    margin: 0;
    padding-left: 28px;
    user-select: none;

    &:before {
        @extend .fas;
        @extend .fa-check;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        color: $color-blue;
        opacity: 0;
    }
    &:hover:not(.disabled) {
        cursor: pointer;
    }
}

.education-filter__input + .education-filter__label:hover:before,
.education-filter__input:checked + .education-filter__label:before {
    opacity: 1;
}

.education-filter__label.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.selected-items li:hover {
    cursor: pointer;
}
</style>
